import { render, staticRenderFns } from "./MenuModal.vue?vue&type=template&id=5cbc75dc&scoped=true&"
import script from "./MenuModal.vue?vue&type=script&lang=js&"
export * from "./MenuModal.vue?vue&type=script&lang=js&"
import style0 from "./MenuModal.vue?vue&type=style&index=0&id=5cbc75dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cbc75dc",
  null
  
)

export default component.exports